export default "__VITE_ASSET__BvvzIT5Z__"